import { Grid, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import css from 'assets/scss/heroSection.module.scss';
import CircularProgressWithLabel from '@Common/components/CircularProgressWithLabel';
import React, { useState, useEffect } from 'react';
import { CHAR_LIMITS } from 'config/constants';

const useStyles = makeStyles((theme: Theme) => ({
  mobileStyles: {
    [theme.breakpoints.down(600)]: {
      marginBottom: '-68px',
    },
  },
}));

const Herosection = () => {
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const [userCount, setUserCount] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 75) {
          clearInterval(timer);
          return 75;
        }
        return prevProgress + 5;
      });
    }, 200);
    const timerForUserCount = setInterval(() => {
      setUserCount((prevUserCount: number) => {
        if (prevUserCount >= 50) {
          clearInterval(timerForUserCount);
          return 50;
        }
        return +(prevUserCount + 5).toFixed(1);
      });
    }, 200);
    return () => {
      clearInterval(timer);
      clearInterval(timerForUserCount);
    };
  }, []);

  return (
    <div className={`${css.container} ${classes.mobileStyles} `}>
      <div className={` ${css.topRoundedBoxHolder} `}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div className={css.roundedBoxHolder}>
              <CircularProgressWithLabel
                value={progress}
                valuetext={`${progress}%`}
                bottomtext="time saved"
              />

              <p>Average time savings per writing project.</p>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div className={css.roundedBoxHolder}>
              <CircularProgressWithLabel
                value={userCount * 2}
                valuetext={`${userCount}+`}
                bottomtext="million"
              />
              <p>Trusted by millions worldwide.</p>
            </div>
          </Grid>
          {/* <Grid item xs={12} sm={4} md={4} lg={4}>
              <div className={` ${css.roundedBoxHolder} `}>
                <div className={` ${css.roundedBox} `}>
                  <img src="./images/landinPage/noCardIcon.svg" alt="card" />
                </div>
                <p>No credit card required.</p>
              </div>
            </Grid> */}

          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div className={css.roundedBoxHolder}>
              <CircularProgressWithLabel
                value={userCount * 2}
                valuetext={`${CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_GUEST}`}
                bottomtext="Words"
              />
              <p>{CHAR_LIMITS.PARAPHRASER_WORD_LIMIT_GUEST} words on a free plan.</p>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Herosection;
